module.exports = __webpack_public_path__ + "static/media/wi-owm-314.4e88c441.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-svg/wi-owm-314.svg
// module id = 807
// module chunks = 0